import React from 'react';

interface Props {
  draftLoading: boolean;
  draftReady: boolean;
  rephraseLoading: boolean;
  rephraseReady: boolean;
}

const AiStatusAnnouncer = ({
  draftLoading,
  draftReady,
  rephraseLoading,
  rephraseReady,
}: Props) => (
  <div className="ai-sr-only" aria-live="polite" role="status">
    {draftLoading && 'Generating AI draft'}
    {draftReady && 'AI draft ready for review'}
    {rephraseLoading && 'Rephrasing selected text'}
    {rephraseReady && 'AI suggestion ready for review'}
  </div>
);

export default AiStatusAnnouncer;
